import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../images/my_btn_mb_w.png";
import { apiWrapper } from "apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { useAppContext } from "utils/store";
import {
  getStatusClassName,
  getStatusColorClassName,
  getStatusImage,
  getStatusName,
} from "utils/common";

export default function AddFireOnItemComponent(props) {
  const [dataSource, setDataSource] = useState(null);

  return (
    <>
      <div className="viewBoard fireOnBoard addFireBoard">
        <TopBoard header={props.header} />
        <MidBoard setDataSource={setDataSource} />
        <StateBoard dataSource={dataSource} />
      </div>
    </>
  );
}

const TopBoard = ({ header }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="top_board mb">
        <div className="wrap_logo">
          {/* <img src="" alt="" className="img_logo"> */}
        </div>
        <div className="header_dept">
          <p className="user">COWORKER</p>
          <div className="wrap_contr">
            <Link className="set_contr" to="">
              <img src={logo} alt="" />
            </Link>
          </div>
        </div>
      </div>

      <div className="top_board navi_board">
        <div className="wrap_navi">
          <button className="arrow_navi" onClick={handleGoBack}>
            <i className="x-icon arrow_icon"></i>
          </button>
          <p className="title_navi">대상물 추가</p>
        </div>
        {header}
        <div className="wrap_right mb">
          <div className="wrap_search pc">
            <div className="box_search">
              <div className="select_box">
                <button className="btn_select">
                  <p>항목</p>
                  <i className="x-icon"></i>
                </button>
                <ul className="list_member">
                  <li>
                    <p>1</p>
                  </li>
                  <li>
                    <p>2</p>
                  </li>
                  <li>
                    <p>3</p>
                  </li>
                </ul>
              </div>
              <input type="text" placeholder="검색어를 입력해주세요." />
              <button className="btn_search">
                <i className="x-icon icon_search"></i>
              </button>
            </div>
          </div>
          <Link className="btn_page_left mb" to="/fireOn_mb.html">
            <i className="x-icon"></i>
          </Link>
        </div>
      </div>
    </>
  );
};

const MidBoard = ({ setDataSource }) => {
  // const searchResultMessages = [
  //     '화재수신기의 일련번호 및 DEI코드를 입력해주세요.',
  //     '화재수신기가 정상적으로 확인되었습니다.',
  //     '화재수신기 일련번호가 존재하지 않거나 DEI가 올바르지 않습니다.',
  // ];

  //const [isModalOpen, setIsModalOpen] = useState(false);
  //const [isNoRegisteredModalOpen, setIsNoRegisteredModalOpen] = useState(false);
  const serialNumberRef = useRef();
  const deiRef = useRef();
  //const [searchResultMessage, setSearchResultMessage] = useState(searchResultMessages[0]);

  const handleSearch = () => {
    const searchSerialNumber = serialNumberRef.current.value;
    const searchDei = deiRef.current.value;

    if (searchSerialNumber === "" || searchDei === "") {
      alert("화재수신기의 일련번호 및 DEI코드를 입력해주세요.");

      // setSearchResultMessage(searchResultMessages[0]);

      // setIsModalOpen(true);
      // setTimeout(() => {
      //     setIsModalOpen(false);
      // }, 3000);
    } else {
      apiWrapper(async () => {
        const { status, data } = await fireonApi.getFireFightingObject(
          searchSerialNumber,
          searchDei
        );
        if (status === true) {
          //setSearchResultMessage(searchResultMessages[1]);
          if (data.isCreated) {
            setDataSource(data);
          } else {
            alert(
              `등록된 대상물 정보가 없습니다.\r\n대상물을 먼저 등록해주세요.`
            );
          }
        } else {
          alert(`${data}`);
        }
      });
    }
  };

  return (
    <>
      <div className="mid_board pc">
        <div className="wrap_mid_le building_mid_le">
          <div className="building_info">
            <div className="item_info">
              <p className="txt_info title_info">일련번호</p>
              <input
                type="text"
                placeholder="화재수신기 일련번호를 입력해주세요."
                ref={serialNumberRef}
              />
            </div>
            <div className="item_info">
              <p className="txt_info title_info">DEI 코드</p>
              <input
                type="text"
                placeholder="화재수신기 DEI 코드를 입력해주세요."
                ref={deiRef}
              />
            </div>
            <button type="button" className="btn_search" onClick={handleSearch}>
              <i className="x-icon icon_search"></i>
            </button>
          </div>
        </div>
        {/* <div className="wrap_right">
                    <div className="wrap_item_contr">
                        <Link className="btn_contr btn_new" to="/fire-on/new">
                            신규 등록
                            <i className="x-icon"></i>
                        </Link>
                    </div>
                </div> */}
      </div>

      {/* {isModalOpen && (
                <div className="modal-overlay show" id="modalOverlay">
                    <div className="modal-content infoResultModal">
                        <div className="modal_inner">
                            <p className="title_cont">{searchResultMessage}</p>
                        </div>
                    </div>
                </div>
            )} */}
    </>
  );
};

const StateBoard = ({ dataSource }) => {
  const [checkedId, setCheckedId] = useState(null);

  const handleAdd = () => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.joinFireFightingObject(
        checkedId
      );
      alert(`${data}`);
    });
  };

  const handleChangeCheck = (e, id) => {
    setCheckedId(id);
  };

  return (
    <div className="stateBoard stateTileBoard">
      {checkedId && (
        <div
          className="toolbar addFiremItemToolbar"
          style={{ display: "block" }}
        >
          <div className="wrap_inner">
            <button className="btn_tb btn_tbAdd" onClick={handleAdd}>
              추가
            </button>
          </div>
        </div>
      )}
      <div className="wrap_state_current">
        <div className="all_current">
          <i className="x-icon icon_info"></i>
          찾으신 대상물을 클릭 후 추가해주세요.
        </div>
      </div>
      <div className="wrap_state">
        {dataSource && (
          <ItemState
            id={dataSource.id}
            status={dataSource.status}
            buildingName={dataSource.buildingName}
            serialNumber={dataSource.serialNumber}
            address={`${dataSource.roadAddress} ${dataSource.roadAddressDetail}`}
            checkedId={checkedId}
            handleChangeCheck={handleChangeCheck}
          />
        )}
      </div>
    </div>
  );
};

const ItemState = ({
  id,
  status,
  buildingName,
  serialNumber,
  address,
  checkedId,
  handleChangeCheck,
}) => {
  return (
    <div
      className={`item_state ${getStatusClassName(status)} ${checkedId === id ? "chkItem" : ""
        }`}
      onClick={(e) => handleChangeCheck(e, id)}
    >
      <div class="item-status-img">
        <img src={getStatusImage(status)} alt="fire-on" />
      </div>
      <div className="wrap_title_item">
        <p className="title_item">{buildingName}</p>
        <div className="adr_item">
          <p className="serial_Code">{serialNumber}</p>
          <span className="bar"></span>
          <p className="text_adr">{address}</p>
        </div>
      </div>
      <div className="wrap_state_item">
        <div className={`cir_state ${getStatusColorClassName(status)}`}></div>
        <p className={`title_state`}>{getStatusName(status)}</p>
      </div>
    </div>
  );
};
